module.exports = "//public.zight.com/packs/media/images/zight-logomark-209cf889e2cdba481f29b444e6a3a75c.svg";